import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../api/agent";
import { UserActivity2 } from "../models/userActivity2";
import { Photo } from "../models/photo";
//import { Photo, UserActivity, ProfileFormValues } from "../models/userActivity";
import { UserActivity } from "../models/userActivity";
import { store } from "./store";

class ProfileStore {
    /* Observables */
    title= 'ProfileStore';
    profile: UserActivity | null = null;
    isLoadingProfile = false;
    isUploading = false;
    isLoading = false;
    followingProfiles: UserActivity[] = [];
    isLoadingFollowings: boolean = false;
    activeTabNumber = 0; //'n >> ProfileFollowingsTaggle
    userActivity2Array: UserActivity2[] = [];
    bLoadingActivities = false;
    
    constructor() {
        makeAutoObservable(this);

        reaction( //'n
            () => this.activeTabNumber, 
            (activeTabNumber_) => { //'n >> ProfileFollowingsTaggle
                if (activeTabNumber_ === 3 || activeTabNumber_ === 4) {
                    const predicate = activeTabNumber_ === 3 ? 'followers' : 'following';
                    this.loadFollowingsTaggle(predicate);
                } else {
                    this.followingProfiles = [];
                }
            }
        )
        
    }

    setActiveTab = (activeTabNumber_: any) => { //'n >> ProfileFollowingsTaggle
        this.activeTabNumber = activeTabNumber_;
    }

    get isCurrentUser() {
        if(store.userStore.user && this.profile) {
            return store.userStore.user.userName === this.profile.userName; // true or false
        } else {
            return false;
        }
    }

    loadProfile = async (username: string) => {
        this.isLoadingProfile = true;

        try {
            const responseData = await agent.Profiles.getProfile(username);

            runInAction(() => {
                this.profile = responseData;
                this.isLoadingProfile = false;
            })

        } catch (error) {
            console.log(error);
            runInAction(() => this.isLoadingProfile = false);
        }
    }

    uploadPhoto = async (fileBlob: Blob) => {
        this.isUploading = true;

        try { 
            const responseData = await agent.Photos.uploadPhoto(fileBlob);
            const photo = responseData.data;

            runInAction(() => {
                if (this.profile) {
                    this.profile.photos?.push(photo);

                    if (photo.isMain && store.userStore.user) {
                        this.profile.photoUrl = photo.url;
                        store.userStore.setImage(photo.url);
                    }
                }

                this.isUploading = false;
            });
        } catch (error) {
            console.log(error);
            runInAction(() => this.isUploading = false);
        }
    }

    setMainPhoto = async (photo: Photo) => {
        this.isLoading = true;

        try {
            await agent.Photos.setMainPhoto(photo.id);
            store.userStore.setImage(photo.url);

            runInAction(() => {
                if(this.profile && this.profile.photos) {
                    //this.profile.photos.find(p => p.isMain)?.isMain = false; // ? is x >> use !
                    this.profile.photos.find(p => p.isMain)!.isMain = false; // it has to be before  this.profile.image = photo.url;

                    this.profile.photoUrl = photo.url;
                    this.profile.photos.find(p => p.id === photo.id)!.isMain = true;

                    this.isLoading = false;
                    //window.location.reload(); // it works
                }
            });
        } catch (error) {
            console.log(error);
            runInAction(() => this.isLoading = false);
        }
    }

    deletePhoto = async (photo: Photo) => {
        this.isLoading = true;

        try {
            await agent.Photos.deletePhoto(photo.id);

            runInAction(() => {
                if(this.profile && this.profile.photos) {
                    this.profile.photos = this.profile.photos?.filter(p => p.id !== photo.id);
                    this.isLoading = false;
                }
            });
        } catch (error) {
            console.log(error);
            runInAction(() => this.isLoading = false);
        }
    }

    //updateProfile = async (profile: UserActivity) => { //. it works
    //updateProfile = async (profile: ProfileFormValues) => {
    updateProfile = async (profile: Partial<UserActivity>) => {
        this.isLoading = true;

        try {
            await agent.Profiles.updateProfile(profile);

            runInAction(() => {
                if (profile.displayName && profile.displayName !== store.userStore.user?.displayName) {
                    store.userStore.setDisplayName(profile.displayName);
                }

                this.profile = { ...this.profile, ...profile as UserActivity };

                this.isLoading = false;
                //window.location.reload(); //.nn it works
            })

        } catch ( error) {
            console.log(error);
            runInAction(() => { this.isLoading = false });
        }
    }

    followTaggle = async (username: string, bFollow: boolean) => { //'n updateFollowing
        this.isLoading = true;

        try {
            await agent.Follow.followTaggle(username);
            store.activityStore.folowAttendeeTaggle(username);

            runInAction(() => { //. runInAction becouse we need to update ProfileStore observables like profile
                //if(this.profile && this.profile.userName !== store.userStore.user?.userName) { //'o
                if(this.profile && this.profile.userName !== store.userStore.user?.userName && this.profile.userName === username) { //'n
                    bFollow ? this.profile.followersCount++ : this.profile.followersCount--;
                    this.profile.bFollowing = !this.profile.bFollowing;
                }

                if(this.profile && this.profile.userName === store.userStore.user?.userName) { //'n
                    bFollow ? this.profile.followingCount++ : this.profile.followingCount--;
                }

                this.followingProfiles.forEach(profile => {
                    if(profile.userName === username) {
                        profile.bFollowing ? profile.followersCount-- : profile.followersCount++;
                        profile.bFollowing = !profile.bFollowing;
                    }
                })
                
                this.isLoading = false;
            });
        } catch (error) {
            console.log(error);
            runInAction(() => { this.isLoading = false; })
        } 
    }

    //loadFollowingsTaggle = async (username: string, predicate: string) => { // nn username
    loadFollowingsTaggle = async (predicate: string) => {
        this.isLoadingFollowings = true;

        try { 
            const profiles = await agent.Follow.getFollowingsTaggle(this.profile!.userName, predicate);

            runInAction(() => {
                this.followingProfiles = profiles;
                this.isLoadingFollowings=false;
            })
            
        } catch (error) {
            console.log(error);
            runInAction(() => { this.isLoadingFollowings=false; })
        }
    }

    loadUserActivities = async (username: string, predicate?: string) => {
        this.bLoadingActivities = true;

        const userActivity2Array =  await agent.Profiles.getActivities(username, predicate!);

        try {
            runInAction(() => { 
                this.userActivity2Array = userActivity2Array;

                console.log( this.userActivity2Array);
                this.bLoadingActivities = false;
            });
        } catch(error) {
            console.log(error);
            runInAction(() => { 
                this.bLoadingActivities = false;
            });

        }


    }


}

export default ProfileStore;